import React, {useCallback} from 'react';
import styled from 'styled-components';
import {useItemContext} from 'shared/components/Accordion/Item';

interface ItemProps {
    children?: React.ReactNode;
}

export const Body = ({children}: ItemProps) => {
    const {isActive} = useItemContext();

    const clickHandler = useCallback((event: React.MouseEvent) => {
        event.stopPropagation();
    }, []);

    if (!isActive) {
        return null;
    }

    return <BodyContainer onClick={clickHandler}>{children}</BodyContainer>;
};

const BodyContainer = styled.div`
    padding: 15px;
`;
